module.exports = __webpack_public_path__ + "static/media/auction-collect-t4.3c1f1682.nom";